import { Row, Col } from "react-grid-system"
import { shareOnFacebook, shareByEmail, shareOnX, shareOnLinkedIn } from "../../utils/share"
import { MailIcon } from "../atoms/icons/MailIcon"
import { FacebookIcon, XIcon, LinkedInIcon } from "../atoms/icons/ShareNewsIcons"
import { HorizontalSpacer } from "../atoms/spacers"
import H2 from "../atoms/typography/H2"
import { theme } from "../theme"

interface ShareLinksProps {
  shareUrl?: string
}

const ShareLinks: React.FunctionComponent<ShareLinksProps> = ({ shareUrl = window.location.href }) => {
  return (
    <div>
      <H2>Share this article</H2>
      <HorizontalSpacer spacing={2} />
      <Row gutterWidth={32}>
        <Col xs="content">
          <a href={shareOnFacebook(shareUrl)} target="_blank">
            <FacebookIcon color={theme.colors.greyDark} />
          </a>
        </Col>
        <Col xs="content">
          <a href={shareByEmail(shareUrl)} target="_blank">
            <MailIcon color={theme.colors.greyDark} />
          </a>
        </Col>
        <Col xs="content">
          <a href={shareOnX(shareUrl)} target="_blank">
            <XIcon color={theme.colors.greyDark} />
          </a>
        </Col>
        <Col xs="content">
          <a href={shareOnLinkedIn(shareUrl)} target="_blank">
            <LinkedInIcon color={theme.colors.greyDark} />
          </a>
        </Col>
      </Row>
    </div>
  )
}

export default ShareLinks
